/**
 * MODAL MENUS
 * This is the global navigation menu modal operator.
 * Adds functionality to close the menu modal when clicked outside the menu.
 *
 * Required modal element DOM structure:
 * <div class='js-modal-menu'>
 * 	  <button class='js-modal-menu-toggle'></button>
 *    <div class='js-modal-menu-list'>
 * 		 your content
 *    </div>
 * </div>
 *
 * Elements can have additional classes as well. The ones listed above are mandatory
 */

const initModalMenus = (modalMenus) => {
	// Define the global menu modal state and active toggle & list elements
	let menuModalActive = false;
	let activeToggle = null;
	let activeList = null;

	// Handle the menu modal reveal event
	function menuReveal(toggle, list) {
		toggle.setAttribute('aria-expanded', 'true');
		list.setAttribute('aria-hidden', 'false');
		menuModalActive = true;
		activeToggle = toggle;
		activeList = list;
	}

	// Handle the menu modal hiding event
	function menuHide(toggle, list) {
		toggle.setAttribute('aria-expanded', 'false');
		list.setAttribute('aria-hidden', 'true');
		menuModalActive = false;
		activeToggle = null;
		activeList = null;
	}

	modalMenus.forEach((menu) => {
		// Define the toggle button and log in list elements
		const toggle = menu.querySelectorAll('.js-modal-menu-toggle')[0];
		const list = menu.querySelectorAll('.js-modal-menu-list')[0];

		// Reveal menu if toggle clicked and is not expanded already
		toggle.addEventListener('click', (e) => {
			if (e.target.getAttribute('aria-expanded') !== 'true') {
				setTimeout(() => {
					menuReveal(toggle, list);
				}, 5);
			}
		});

		// Check if modal has a dedicated close button and handle the close operation
		const closeBtn = menu.querySelectorAll('.js-modal-menu-close-btn')[0];
		if (closeBtn) {
			closeBtn.addEventListener('click', () => {
				menuHide(activeToggle, activeList);
			});
		}
	});

	// Add delegated click event listener to detect document clicks
	// Hide the menu if clicked outside the menu
	document.addEventListener('click', (e) => {
		if (menuModalActive) {
			if (!activeList.contains(e.target)) {
				menuHide(activeToggle, activeList);
			}
		}
	});
};

const init = () => {
	const modalMenus = document.querySelectorAll('.js-modal-menu');

	if (modalMenus.length) {
		initModalMenus(modalMenus);
	}
};

document.addEventListener('DOMContentLoaded', init);
